import { render, staticRenderFns } from "./NotificationsAndAlerts.vue?vue&type=template&id=0cb52c58&scoped=true&"
import script from "./NotificationsAndAlerts.vue?vue&type=script&lang=js&"
export * from "./NotificationsAndAlerts.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsAndAlerts.vue?vue&type=style&index=0&id=0cb52c58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb52c58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VForm,VProgressCircular,VRow})
